import { useEffect, useState } from "react";
import axios from "axios";
import { AUTH_API_URL } from "../config";

// Fired whenever someone signs in or out, so the header can update straight away.
const AUTH_EVENT = "carsense:auth";

export function getToken() {
  return localStorage.getItem("token");
}

export function getStoredUser() {
  try {
    const user = localStorage.getItem("user");
    return getToken() && user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
}

export function storeSession(token, user) {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function signOut() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function useCurrentUser() {
  const [user, setUser] = useState(getStoredUser);

  useEffect(() => {
    const update = () => setUser(getStoredUser());
    window.addEventListener(AUTH_EVENT, update);
    window.addEventListener("storage", update);
    return () => {
      window.removeEventListener(AUTH_EVENT, update);
      window.removeEventListener("storage", update);
    };
  }, []);

  return user;
}

export function authHeaders(token = getToken()) {
  return { Authorization: `Bearer ${token}` };
}

// Saves a registration search to the signed-in user's history.
export function saveSearch({ registration, make, model, faults }, token = getToken()) {
  return axios.post(
    `${AUTH_API_URL}/api/auth/save-search`,
    { registration, make, model, faults },
    { headers: authHeaders(token) }
  );
}
